import React, {Component} from 'react';
import {ListGroupItem} from 'reactstrap';
import TemplatePreview from 'template/components/TemplatePreview';
import {connect} from 'react-redux';
import {selectTemplate} from 'template/actions';

@connect(
    state => ({
        selectedTemplate: state.template.selectedTemplate,
        selectedTemplateCategory: state.template.selectedTemplateCategory,
    }),
    dispatch => {
        return {
            select: (manual) => dispatch(selectTemplate(manual))
        }
    }
)
export class Template extends Component {

    render() {
        const {
            selectedTemplate,
            template,
            select,
            index
        } = this.props;
        const isTemplateSelected = selectedTemplate && template.id === selectedTemplate.id
        return (
            <ListGroupItem key={`template_${template.id}`}>
                {
                    isTemplateSelected &&
                    <TemplatePreview/>
                }
                {
                    !isTemplateSelected &&
                    <button
                        className={'btn btn-link'}
                        onClick={() => select(template)}
                    >
                        {index}. {template.name}
                    </button>
                }
            </ListGroupItem>
        )
    }
}
